import Analytics from '@/utils/analytics';
import i18n from '@/utils/i18n';
import React from 'react';
import { BubbleProps } from 'react-native-gifted-chat';
import { ChatActionMessage } from './chat-action-message';
import { ChatDetails_ChatMessageCreditRequestMessageFragment } from '@/types';
import { Message, OnCreditRequestPressType } from './types';

export type ChatMessageCreditRequestProps = BubbleProps<Message> & {
  onCreditRequestPress: OnCreditRequestPressType;
};

export const ChatMessageCreditRequest: React.FC<
  ChatMessageCreditRequestProps
> = ({ onCreditRequestPress, ...rest }) => {
  const currentMessage = rest.currentMessage as Message;
  const creditRequestBatch =
    currentMessage.creditRequestBatch as ChatDetails_ChatMessageCreditRequestMessageFragment['credit_request_batch'];

  return (
    <ChatActionMessage
      {...rest}
      buttonText={i18n.t('view_request')}
      onPress={() => {
        Analytics.track('chat_message.view_credit_request_button.press', {
          creditRequestBatchUUID: creditRequestBatch.uuid,
        });
        onCreditRequestPress(creditRequestBatch.uuid);
      }}
      title={i18n.t('credit_requested')}
    />
  );
};
